// Footer.jsx
import React from "react";
import "./BasicFooter.css";
import Waves from "./Waves";
import { Facebook, X, Instagram, Linkedin, MessageCircle, Mail } from 'lucide-react';

const BasicFooter = ({ openContactModal }) => {
  const currentYear = new Date().getFullYear();

  const handleContactClick = (e) => {
    e.preventDefault();
    openContactModal();
  };

  return (
    <>
      <Waves />
      <div className="connector"></div>
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-container">
            <div className="footer-actions">
              {/* Contact button with highlight effect */}
              <button 
                className="contact-button" 
                onClick={handleContactClick}
                data-interactive
              >
                <MessageCircle size={20} />
                Let's Link!
              </button>
              
              <div className="contact-options">
                <a href="mailto:eveyfayegriffiths@gmail.com" aria-label="Email me" data-interactive>
                  <Mail className="social-icon" size={24} />
                </a>
                <a href="https://www.instagram.com/eveylicious/" aria-label="Instagram" data-interactive>
                  <Instagram className="social-icon" size={24} />
                </a>
                <a href="https://www.linkedin.com/in/eveygriffiths/" aria-label="LinkedIn" data-interactive>
                  <Linkedin className="social-icon" size={24} />
                </a>
              </div>
            </div>
          </div>

          {/* <div className="footer-links">
            <div className="link-group">
              <h3>Company</h3>
              <ul>
                <li>
                  <a href="/">About</a>
                </li>
                <li>
                  <a href="/">Careers</a>
                </li>
                <li>
                  <a href="/">Blog</a>
                </li>
              </ul>
            </div>

            <div className="link-group">
              <h3>Resources</h3>
              <ul>
                <li>
                  <a href="/">Documentation</a>
                </li>
                <li>
                  <a href="/">Help Center</a>
                </li>
                <li>
                  <a href="/">Tutorials</a>
                </li>
              </ul>
            </div>

            <div className="link-group">
              <h3>Legal</h3>
              <ul>
                <li>
                  <a href="/">Privacy Policy</a>
                </li>
                <li>
                  <a href="/">Terms of Service</a>
                </li>
                <li>
                  <a href="/">Cookie Policy</a>
                </li>
              </ul>
            </div>
          </div> */}
        </div>

        <div className="footer-bottom">
          <div className="copyright">
            <p>&copy; {currentYear} eveylicious. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default BasicFooter;
